var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_548_1788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1851 18.6499H24.757C20.7868 18.6499 17.5684 21.8684 17.5684 25.8385V26.2666C17.5684 30.2368 20.7868 33.4552 24.757 33.4552H25.1851C29.1552 33.4552 32.3737 30.2368 32.3737 26.2666V25.8385C32.3737 21.8684 29.1552 18.6499 25.1851 18.6499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6965 1.36767L8.10902 11.047C7.05547 12.8706 8.3731 15.15 10.4774 15.15H21.6551C23.7594 15.15 25.0771 12.8706 24.0235 11.047L18.4305 1.36767C17.3769 -0.455891 14.7472 -0.455891 13.6937 1.36767H13.6965Z",
    fill: "#F36D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70011 34.0001C11.9528 34.0001 15.4002 30.5526 15.4002 26.3C15.4002 22.0473 11.9528 18.5999 7.70011 18.5999C3.44746 18.5999 0 22.0473 0 26.3C0 30.5526 3.44746 34.0001 7.70011 34.0001Z",
    fill: "#F89B60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_548_1788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.3738,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialDesign);
export default __webpack_public_path__ + "static/media/materialDesign.b44404ab7f1a138af98a10f590254d6c.svg";
export { ForwardRef as ReactComponent };